export const ENGAGEMENT_CHART_DATE_RESTRICTION =
  'Please choose a time period of more than 3 months for Giving Engagement'
